import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52847c80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "hero",
  ref: "heroRef"
}
const _hoisted_2 = { class: "hero__image_container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "hero__date" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hero__date__line" }, null, -1))
const _hoisted_6 = { class: "hero__title" }
const _hoisted_7 = {
  key: 0,
  class: "hero__introduction"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "hero__image remove-mix-blend-mode hero__image--with-gradient",
        "data-scrolltrigger-start": "0",
        style: _normalizeStyle(`background-image:url(${_ctx.image})`)
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.date), 1),
        (_ctx.date2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.date2), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.title), 1),
      (_ctx.introduction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.introduction), 1))
        : _createCommentVNode("", true)
    ])
  ], 512))
}